import { Box } from '@mui/material'
import React from 'react'

const LoadingPage = () => {

    
    return (
        <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center',opacity:".6" }}>
            <img
                src={process.env.REACT_APP_IMAGE_URL + 'sideBarSvg/Centilio.png'}
                //    className={styles.centilio_header_icon}
                style={{ width: '50px' }}
                alt='welcome-img'
            />
            <span style={{fontSize:'40px',fontWeight: '700',lineheight: 'normal'}}>Centilio</span>
        </Box>
    )
}

export default LoadingPage